import type { Address } from 'src/components/checkout/steps/shipping/types'

import { axiosClient } from '../../../../services/axiosInstance'
import { OrderForm } from '../../entity/orderForm'

export const addCartShippingData = async (orderFormId: string, cep: string) => {
  const { data } = await axiosClient.post(
    `/api/checkout/orderForm/${orderFormId}/shippingData`,
    {
      cep,
    }
  )

  return new OrderForm(data)
}

export const addCartShippingDataV2 = async (
  orderFormId: string,
  selectedAddresses: Array<{
    addressId?: string
    addressType?: string
    city?: string
    complement?: string
    country?: string
    isDisposable?: boolean
    neighborhood?: string
    number?: string
    postalCode?: string
    receiverName?: string
    reference?: string
    state?: string
    street?: string
  }>,
  logisticsInfo?: Array<{
    selectedSla: string | null
    selectedDeliveryChannel: string | null
    itemIndex: number
    addressId?: string | null
  }>
) => {
  const { data } = await axiosClient.post(
    `/api/checkout/orderForm/${orderFormId}/shippingData`,
    {
      clearAddressIfPostalCodeNotFound: false,
      selectedAddresses,
      logisticsInfo,
    }
  )

  return new OrderForm(data)
}

// Reset logistic info allowing simulation to be recalculated
export const clearCartLogisticInfo = async (
  orderForm: OrderForm,
  address?: Address
) => {
  try {
    const { orderFormId, shippingData } = orderForm ?? {}

    if (!orderFormId || !shippingData) {
      return orderForm
    }

    const logisticsInfo = shippingData?.logisticsInfo?.map((info) => {
      return {
        itemIndex: info?.itemIndex,
        selectedSla: null,
        selectedDeliveryChannel: null,
        addressId: null,
      }
    })

    const selectedAddresses = address
      ? [address]
      : shippingData?.selectedAddresses ?? []

    const { data } = await axiosClient.post(
      `/api/checkout/orderForm/${orderFormId}/shippingData`,
      {
        selectedAddresses,
        logisticsInfo,
      }
    )

    return new OrderForm(data)
  } catch {
    return orderForm
  }
}
